"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BOREALIS_COLORS_PALETTE = void 0;
exports.BOREALIS_COLORS_PALETTE = [
    '#16C5C0',
    '#A6EDEA',
    '#61A2FF',
    '#BFDBFF',
    '#EE72A6',
    '#FFC7DB',
    '#F6726A',
    '#FFC9C2',
    '#EAAE01',
    '#FCD883',
];
//# sourceMappingURL=borealis_colors.js.map